(function (app, ng) {
    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider
            .state("Home.Tools.MarketingTrackerNew.Kits.Onboarding",
                {
                    url: "/Onboarding",
                    component: "onboardingKitNew",
                    PageTitle: "Onboarding Kits | Marketing Tracker",
                    resolve: {
                        attempt: ["marketingKitApi", function (marketingKitApi) {
                            return marketingKitApi.getOnboardingKit().then(function (kit) {
                                return kit;
                            }, function () {
                                return null;
                            });
                        }]
                    }
                });
    }]);

    app
        .component("onboardingKitNew",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Kits/Onboarding/onboarding-new-template.html",
                controller: onboardingKitNewController,
                bindings: {
                    attempt: "<"
                }
        });

    onboardingKitNewController.$inject = ["marketingKitApi", "$timeout", "$mdDialog", "$window", "$filter", "$state", "figToaster"];
    function onboardingKitNewController(marketingKitApi, $timeout, $mdDialog, $window, $filter, $state, figToaster) {
        var $ctrl = this;

        if ($ctrl.attempt !== null) {
            $ctrl.isSubmitted = $ctrl.attempt.IsSubmitted;
            $ctrl.form = JSON.parse($ctrl.attempt.JsonData);
            $ctrl.formCopy = ng.copy($ctrl.form);
        }
        else $ctrl.attempt = {};

        ng.extend($ctrl,
            {
                save: save,
                autoSave: autoSave,
                error: error,
                buildProgressBar: buildProgressBar,
                UI: {
                    isSaving: false,
                    isSubmitting: false,
                    submitMessage: "Your Onboarding kit has been submitted.",
                    saveMessage: "Your Onboarding kit has been saved.",
                    autoSaveMessage: "Your Onboarding kit has been auto saved.",
                    progress: 0
                }
            });

        function buildProgressBar() {
            if ($ctrl.attempt.IsSubmitted) {
                $ctrl.UI.progress = 100;
            }
            else if ($ctrl.attempt.ModifiedOn) {
                $ctrl.UI.progress = 60;
            }
            else $ctrl.UI.progress = 0;
        }
        buildProgressBar();

        function autoSave($event) {
            $timeout.cancel($ctrl.autoSaveTimeout);
            if ($event.ctrlKey && $event.keyCode === 83) {
                $event.preventDefault();
                save($ctrl.form, false, false);
            } else {
                $ctrl.autoSaveTimeout = $timeout(function () {
                    if (!ng.equals($ctrl.form, $ctrl.formCopy) && !$ctrl.isAutoSaved) {
                        save($ctrl.form, false, true);
                    }
                }, 5000);
            }
        }

        function error($event) {
            //var errorMsg = $mdDialog.alert({
            //    title: "We're sorry, there was an error saving your kit. Please contact your sales consultant if this error continues.",
            //    targetEvent: $event,
            //    ariaLabel: "Saving Error",
            //    ok: "OK",

            //    multiple: true,
            //    clickOutsideToClose: false
            //});

            //$mdDialog.show(errorMsg).then(function () {
            //    $mdDialog.hide();
            //    $state.reload();
            //});

            //console.log("Error: " + error.data);
            message = "There was a problem saving your kit. Please try again shortly.";
            toastClass = "is-error";
            $state.reload();
            return figToaster.showSimple(message, "top", toastClass);
        }

        function save(form, isSubmitted, autoSaved) {

            if (isSubmitted) {
                $ctrl.UI.isSubmitting = true;
                $ctrl.attempt.IsSubmitted = true;
                $ctrl.attempt.CompletedOn = $filter('date')(new Date(), "medium");
            } else {
                $ctrl.UI.isSaving = true;
                $ctrl.attempt.IsSubmitted = false;
                $ctrl.attempt.ModifiedOn = $filter('date')(new Date(), "medium");
            }
            buildProgressBar();
            $ctrl.attempt.JsonData = JSON.stringify(form);

            marketingKitApi.saveOnboardingKit($ctrl.attempt).then(function () {

                $ctrl.isSubmitted = isSubmitted;

                if (!isSubmitted) {
                    autoSaved ? $ctrl.isAutoSaved = true : $ctrl.isSaved = true;
                    $ctrl.form = JSON.parse($ctrl.attempt.JsonData);
                    $ctrl.formCopy = ng.copy($ctrl.form);
                    $timeout(function () {
                        $ctrl.isSaved = false;
                        $ctrl.isAutoSaved = false;
                    }, 2000);
                }

                $ctrl.UI.isSubmitting = false;
                $ctrl.UI.isSaving = false;
                //if (isSubmitted)
                //    $window.location.reload();
            }, function () {
                $ctrl.UI.isSubmitting = false;
                $ctrl.UI.isSaving = false;
                error();
            });
        }
    }

})(window.app, window.angular); // jshint ignore:line